import * as React from 'react';
import { loadScript, type Options as ScriptOptions } from '@avensia/excite';
import { useOnScreen } from './use-on-screen';

type Options = {
  rootMargin?: string;
  initialState?: boolean;
  onScriptLoaded?: () => void;
  options?: ScriptOptions;
};

export function useLoadScriptOnScreen<T extends HTMLElement>(
  url: string | undefined,
  { initialState, onScriptLoaded, rootMargin, options }: Options = { initialState: false, rootMargin: '400px' },
) {
  const [isInViewport, ref] = useOnScreen<T>(rootMargin ?? '400px', initialState ?? false);
  const onLoadScriptRef = React.useRef(onScriptLoaded);
  onLoadScriptRef.current = onScriptLoaded;
  const optionsRef = React.useRef(options);
  optionsRef.current = options;

  React.useEffect(() => {
    if (url && isInViewport) {
      loadScript(url, optionsRef.current).then(() => onLoadScriptRef.current?.());
    }
  }, [isInViewport, url]);

  return ref;
}
